import {
    Problem,
} from '@michel.freiha/ng-sdk';


export class AddProblemFromErrorHandler {
    public static readonly type: string = '[Error Handler] Add problem';
    constructor(public problem: Problem) { }
}
